import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import RestaurantItem from './RestaurantItem';

interface RestaurantListProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const RestaurantList: React.FC<RestaurantListProps> = observer(({ restaurantOfferStore }) => {
    const { restaurants, onRestaurantClick } = restaurantOfferStore;
    return (
        <Box
            display={"grid"}
            gridTemplateColumns={{xs: "repeat(1, minmax(0, 1fr))", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))"}}
            flexDirection={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            gap={2}
            sx={{
                width: "100%",
                maxWidth: 'lg'
            }}>
            {_.map(restaurants, (restaurant) => (
                <RestaurantItem
                    key={restaurant.id}
                    restaurant={restaurant}
                    onClick={onRestaurantClick} />
            ))}
        </Box>

    )
})

export default RestaurantList;